/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Creative } from '../models/Deployservicev3Creative';
import { V3Segment } from '../models/V3Segment';
import { V3StackAdaptCampaign } from '../models/V3StackAdaptCampaign';
import { HttpFile } from '../http/http';

/**
* The configuration for StackAdapt deployment destinations
*/
export class V3StackAdaptConfiguration {
    /**
    * ID of the Order Line.
    */
    'orderLineId'?: string;
    /**
    * ID of the Organization.
    */
    'advertiserId'?: string;
    /**
    * The URL the user will be redirected to if the creative is clicked.
    */
    'clickThroughUrl'?: string;
    'stackadaptCampaign'?: V3StackAdaptCampaign;
    /**
    * Creatives that will be deployed.
    */
    'creatives'?: Array<Deployservicev3Creative>;
    /**
    * Segments that will be deployed.
    */
    'segments'?: Array<V3Segment>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiserId",
            "baseName": "advertiser_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "clickThroughUrl",
            "baseName": "click_through_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "stackadaptCampaign",
            "baseName": "stackadapt_campaign",
            "type": "V3StackAdaptCampaign",
            "format": ""
        },
        {
            "name": "creatives",
            "baseName": "creatives",
            "type": "Array<Deployservicev3Creative>",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "Array<V3Segment>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptConfiguration.attributeTypeMap;
    }

    public constructor() {
    }
}

